<template>
	<!-- begin #footer -->
	<div id="footer" class="footer">
		&copy; Smart Claim Systems 2021. Version {{version}}
	</div>
	<!-- end #footer -->
</template>

<script>
import PageOptions from '@/Options/PageOptions.js'
import {version} from './../../../package.json'

export default {
  name: 'Footer',
  data() {
		return {
			pageOptions: PageOptions,
			version
		}
  }
}
</script>
